import { useContext } from "react"
import { Context } from "../context/ContextProvider"

export const useEnvironment = () =>{

  const context = useContext(Context);

  if (!context){
    return {};
  }

  return context;
  
}